import { Pipe, PipeTransform } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { environment } from "../../environments/environment";

declare var require: any;
@Pipe({ name: "thumbnails", pure: false })
export class Thumbnail implements PipeTransform {
  src: any;
  transform(imageData: any, thumbnailType): any {
    if (imageData) {
      imageData.forEach((element) => {
        if (element.image_type === thumbnailType) {
          this.src = element.asset;
        }
      });
      if (!this.src) {
        if (thumbnailType === "landscape") {
          this.src = environment.landscapeDefault;
        } else if (thumbnailType === "portrait") {
          this.src = environment.portraitDefault;
        } else if (thumbnailType === "square") {
          this.src = environment.squareDefault;
        }
      }
      return this.src;
    }
  }
}
@Pipe({ name: "redirectUrl", pure: false })
export class Makeurl implements PipeTransform {
  src: any;
  transform(data: any): any {
    if (data) {
      let datail: any;
      if (data.series_id) {
        datail = ["/series", data.series_id];
      } else {
        datail =
          data.source == "system" && data.type == "video"
            ? ["/video-detail", data.public_id]
            : (data.source == "youtube" ||
              data.source == "vimeo" ||
              data.source == "daily_motion") &&
              data.type == "video"
              ? ["/provider/" + data.source + "/" + data.public_id]
              : data.source == "system" &&
                data.type == "video" &&
                data.extension == "document"
                ? ["/document-detail", data.public_id]
                : data.source == "system" &&
                  data.type == "video" &&
                  data.extension == "audio"
                  ? ["/audio-detail", data.public_id]
                  : data.source == "system" && data.type == "live"
                    ? ["/video-detail", data.public_id]
                    : data.source == "system" && data.type == "series"
                      ? ["/series", data.public_id]
                      : data.source == "system" && data.type == "album"
                        ? ["/music-player", data.public_id]
                        : data.source == "system" && data.type == "podcast"
                          ? ["/music-player", data.public_id]
                          : data.source == "system" && data.type == "music"
                            ? ["/song-detail", data.public_id]
                            : ["/series", data.source, data.public_id];
      }
      return datail;
    }
  }
}

@Pipe({ name: "queryParamUrl" })
export class queryParamUrl implements PipeTransform {
  transform(data: any): any {
    let query: any
    if (data) {
      query = data.source == "system" && data.type == "album"
        ? { type: 'musicDetail', slug: 'music' }
        : data.series_id
          ? { episode: data.public_id }
          : data.source == "system" && data.type == "podcast"
            ? { type: 'musicDetail', slug: data.type }
            : ''
      return query
    }
  }
}

